export const iconFontAwesomeCommunicationTty = (
	<i className="fa-solid fa-tty"></i>
);
